<div class="fx-row" id="complete">
  <div class="fx-row fx-flex-100">
    <div class="gt-sm-fx-flex-10"></div>
    <div class="completeBox fx-flex-100 gt-sm-fx-flex-80">
      <mat-card appearance="outlined">
        <mat-card-header class="bg-color">
          <mat-card-title class="p-16">
            <span class="color-f-s-20 c-white" translate="thank_for_order"></span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="p-16 fx-col">
            <div class="m-b-15 fx-row">
              <div class="fx-flex-50">
                <mat-label class="color-f-s-14" translate="your_memberid"></mat-label>
              </div>
              <div class="fx-flex-50">
                <mat-label class="color-f-s-14"
                [textContent]="userService.customerData.BackOfficeId"></mat-label>
                @if (userEnrollmentDetail?.AssociateID && !userService.customerData.BackOfficeId) {
                  <mat-label class="color-f-s-14"
                  [textContent]="$safeNavigationMigration(userEnrollmentDetail?.AssociateID)"></mat-label>
                }
              </div>
            </div>

            @if (!guest && userService.webOffice?.UserName) {
              <div class="m-b-15 fx-row">
                <div class="fx-flex-50">
                  <mat-label class="color-f-s-14" translate="your_user_name">
                  </mat-label>:
                </div>
                <div class="fx-flex-50">
                  <mat-label class="color-f-s-14"
                  [textContent]="$safeNavigationMigration(userService.webOffice?.UserName)"></mat-label>
                </div>
              </div>
            }
            @if (userService.webOffice?.Password) {
              <div class="m-b-15 fx-row">
                <div class="fx-flex-50">
                  <mat-label class="color-f-s-14" translate="Password">
                  </mat-label>:
                </div>
                <div class="fx-flex-50" (ngInit)="isShowPassword=false">
                  @if (isShowPassword) {
                    <mat-label class="color-f-s-14" [textContent]="$safeNavigationMigration(userService.webOffice?.Password)"
                    ></mat-label>
                  }
                  @if (!isShowPassword) {
                    <mat-label class="color-f-s-14">
                      @for (a of passwordLength; track $index) {
                        <span>*</span>
                      }</mat-label>
                    }
                    @if (!isShowPassword) {
                      <mat-label class="cursor-pointer color-f-s-14" (click)="isShowPassword=true"
                        ><mat-icon>visibility</mat-icon></mat-label>
                      }
                      @if (isShowPassword) {
                        <mat-label class="cursor-pointer color-f-s-14" (click)="isShowPassword=!isShowPassword"
                          ><mat-icon>visibility_off</mat-icon></mat-label>
                        }
                      </div>
                    </div>
                  }
                  @if (IsApplication) {
                    <div class="m-b-15 fx-row">
                      <div class="fx-flex-50">
                        <mat-label class="color-f-s-14" translate="your_email_id">
                        </mat-label>:
                      </div>
                      <div class="fx-flex-50">
                        <mat-label class="color-f-s-14 word-wrap"
                        [textContent]="$safeNavigationMigration(userService.personalInfo?.Email)"></mat-label>
                      </div>
                    </div>
                  }
                  @if (SubmitApplicationResponse?.OrderID > 0) {
                    <div class="m-b-15 fx-row">
                      <div class="fx-flex-50">
                        <mat-label class="color-f-s-14" translate="your_orderid">
                        </mat-label>
                      </div>
                      <div class="fx-flex-50">
                        <a class="cursor-pointer color-f-s-14 c-blue text-underline"
                          (click)="showOrderInvoice($safeNavigationMigration(SubmitApplicationResponse?.OrderID))"
                        [textContent]="$safeNavigationMigration(SubmitApplicationResponse?.OrderID)"></a>
                      </div>
                    </div>
                  }
                  <div class="clearfix"></div>
                </div>
              </mat-card-content>
              <mat-card-actions>
                <div class="fx-row fx-main-end fx-cross-center">
                  <div class="m-8">
                    <button mat-raised-button color="primary" class="m-r-10" (click)="goToProduct()"
                    translate="" aria-mat-label="KeepShopping">{{'keep_shopping' | translate}}</button>
                  </div>
                </div>
              </mat-card-actions>
            </mat-card>
          </div>
          <div class="gt-sm-fx-flex-10"></div>
        </div>
      </div>